/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from 'react-router-dom';

import Typography from '@mui/material/Typography';

import Link from '@mui/material/Link';
import ResponsiveHeader from 'layouts/ResponsiveHeader';
import './App.css';
import { blue, purple } from '@mui/material/colors';
import Home from 'pages/Home';
import Activities from 'pages/Activities';
import Schedules from 'pages/Schedules';
import News from 'pages/News';
import Sponsors from 'pages/Sponsors';
import AboutUs from 'pages/AboutUs';
import JoinUs from 'pages/JoinUs';

function Copyright() {
  const blueColor = blue[500];

  const purpleColor = purple[300];
  return (
    <Typography variant='body2' align='center'>
      {'Copyright ©  '}
      {new Date().getFullYear()}
      &nbsp;&nbsp;
      <Link color={blueColor} href='https://wimss.org/'>
        YEGWIMSS 爱城活力社
      </Link>
      {'.'}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;Created by:
      &nbsp;&nbsp;Ning&nbsp;Zheng&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;Graphic
      resource:&nbsp;&nbsp;
      <Link color={purpleColor} href='https://www.vecteezy.com/'>
        Vecteezy.com
      </Link>
      {'.'}
    </Typography>
  );
}

const Redirect = (props) => {
  const navigate = useNavigate();
  const { url } = props;
  useEffect(() => {
    window.open(url, '_blank');
    navigate('/news');
  }, [url]);
  return (
    <div>{/* <Link to={{ pathname: url }} target="_blank"></Link> */}</div>
  );
};

export default function App() {
  return (
    <Fragment>
      <div
        className='App'
        style={{ fontFamily: 'Montserrat', fontWeight: '500' }}>
        <header>
          <ResponsiveHeader />
        </header>

        <div>
          <Routes>
            <Route exact path='/' element={<Home />} />
            <Route exact path='/home' element={<Home />} />
            <Route exact path='/activities' element={<Activities />} />
            <Route exact path='/schedules' element={<Schedules />} />
            <Route exact path='/news' element={<News />} />
            <Route exact path='/sponsors' element={<Sponsors />} />
            <Route
              exact
              path='/boardroom'
              element={
                <Redirect url={'https://meet.google.com/bat-qeku-aev'} />
              }
            />
            <Route exact path='/about-us' element={<AboutUs />} />
            <Route exact path='/join-us' element={<JoinUs />} />
            <Route path='*' element={<Navigate to='/' replace />} />

            {/* 
        
        
        
        
        <Route path='*' element={<NotFound />} /> */}
          </Routes>

          <footer id='footer'>
            <Copyright />
          </footer>
        </div>
      </div>
    </Fragment>
  );
}
